import { CustomLabel } from "./CustomLabel";
import { Form } from "react-bootstrap";

interface VisualizacaoTextAreaProps {
  id: string;
  label?: string;
  value: any;
  rows?: number;
  direcaoExpansao: "both" | "horizontal" | "vertical" | "none";
}

const VisualizacaoTextArea: React.FC<VisualizacaoTextAreaProps> = (props) => {
  const classNameResize = `resize-${props.direcaoExpansao}`;

  return (
    <>
      {props.label && <CustomLabel>{props.label}</CustomLabel>}
      <Form.Control
        style={{ fontSize: "1rem" }}
        id={props.id}
        className={`input-gc ${classNameResize}`}
        as={"textarea"}
        rows={props.rows}
        readOnly
        value={props.value || ""}
        disabled
      />
    </>
  );
};

export default VisualizacaoTextArea;
